<template>
  <div id="app">
    <header class="header">
      <div class="header-inner">
        <div class="header__subheading">A new way to explore Japan</div>
        <h1>The Discovery Dial</h1>
        <div class="container">
          <div class="row">
            <div class="col-12 col-lg-5 header-logos-outer">
              <SvgLogoJnto class="header__logo header__logo--jnto"/>
              <SvgLogoJed class="header__logo header__logo--jed"/>
              <SvgLogoJal class="header__logo header__logo--jal"/>
              <SvgLogoGa class="header__logo header__logo--ga"/>
            </div>
          </div>
        </div>
      </div>
      <img src="~@/assets/images/header-image.png" class="w-100 header__bg">
    </header>

    <main>
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-8 mx-auto">
            <h2 class="pb-2">The Challenge</h2>
            <p>Japan National Tourism Organization were looking for a co-operative campaign with tourism partners that would increase visitation to Japan, grow awareness about the diversity of the destination and experiences available to travellers and drive database acquisition. </p>

            <h2 class="mt-5 pt-4 pb-3">Insight</h2>
            <p>Our insight was that Australian travellers are increasingly choosing holiday destinations based on the type of experiences and change of pace they are looking for. This was combined with the fact that Japan is home to a full spectrum of holiday opportunities, unlike any other place in the world. Nowhere is there a place that both embraces the hustle and bustle from A to B at bullet speed; and philosophies centred on stillness and an appreciation for slow living.</p>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col-12 my-5">
            <img class="d-block mx-auto w-100"
              src="~@/assets/images/slides-image.png"
              srcset="~@/assets/images/slides-image@2x.png 2x, ~@/assets/images/slides-image@3x.png 3x">
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-lg-8 mx-auto mb-5 pb-5">
            <h2 class="pb-2">The Solution</h2>
            <p>We created The Discovery Dial, an interactive visual interface that flips the conventional method of browsing holiday options on its head, showcasing Japan through the broad range of options that the destination has to offer by the pace of each experience.</p>
            <p>Users were invited to browse these options, by using the dial to increase or decrease the pace of experience from slow to fast. They were then invited to choose their top 3 activities for a chance to enter a competition to win a trip to Japan with prize partners JAL and G Adventures.</p>
            <p>Participants were emailed a confirmation of their entry along with details of the activities that they had chosen to further increase awareness and intention to book.  </p>
          </div>
        </div>
      </div>

      <div class="slider w-100 mt-2 position-relative">
        <flickity ref="flickity" :options="flickityOptions">
          <div class="carousel-cell mx-3">
            <img src="~@/assets/images/carousel-img-1.jpg"
                 srcset="~@/assets/images/carousel-img-1@2x.jpg 2x,
                 ~@/assets/images/carousel-img-1@3x.jpg 3x"
                 width="755"
                 height="525">
          </div>
          <div class="carousel-cell mx-3">
            <img src="~@/assets/images/carousel-img-2.jpg"
                 srcset="~@/assets/images/carousel-img-2@2x.jpg 2x,
                 ~@/assets/images/carousel-img-2@3x.jpg 3x"
                 width="755"
                 height="525">
          </div>
          <div class="carousel-cell mx-3">
            <img src="~@/assets/images/carousel-img-3.jpg"
                 srcset="~@/assets/images/carousel-img-3@2x.jpg 2x,
                 ~@/assets/images/carousel-img-3@3x.jpg 3x"
                 width="755"
                 height="525">
          </div>
          <div class="carousel-cell mx-3">
            <img src="~@/assets/images/carousel-img-4.jpg"
                 srcset="~@/assets/images/carousel-img-4@2x.jpg 2x,
                 ~@/assets/images/carousel-img-4@3x.jpg 3x"
                 width="694"
                 height="395">
          </div>
        </flickity>
        <div class="slider-arrows">
          <button @click="previous()" class="slider__arrow slider__arrow--left"><IcoArrow/></button>
          <button @click="next()" class="slider__arrow slider__arrow--right"><IcoArrow/></button>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-8 mx-auto my-5">
            <p>
              Circul8 built the competition mechanic including design and development, negotiated cooperative partnership with JAL and G Adventures and managed the social media paid advertising to drive awareness and entries to the competition.<br><br>
            </p>
          </div>
        </div>

        <div class="container">
          <div class="row mb-5">
            <div class="col-12 col-lg-10 mx-auto">
              <img src="~@/assets/images/devices.png"
                   srcset="~@/assets/images/devices@2x.png 2x,
                   ~@/assets/images/devices@3x.png 3x"
                  class="w-100">
            </div>
          </div>
        </div>


        <div class="row results">
          <div class="col-12 col-lg-8 mx-auto">
            <h2 class="mb-4">Results</h2>
          </div>
        </div>

            <div class="row justify-content-center">
              <div class="col-12 col-lg-8 mx-auto">
                <div class="row no-gutters">
              <div class="col-12 col-xs-6 col-lg-4">
                <div class="results__box">
                <h3 class="results__heading">
                  <count-to
                          ref="counter_1"
                          :startVal="0"
                          :endVal="50468"
                          :duration=3000
                          :decimals="0"
                          :autoplay="false"
                          separator=","
                          prefix="+"
                  />
                </h3>
                <p class="results__copy">new email<br> subscribers</p>
                </div>
              </div>
              <div class="col-12 col-xs-6 col-lg-4">
                <div class="results__box">
                <h3 class="results__heading">
                  <count-to
                          ref="counter_2"
                          :startVal="0"
                          :endVal="58855"
                          :duration=4000
                          :decimals="0"
                          :autoplay="false"
                          separator=","
                          prefix=""
                  />
                </h3>
                <p class="results__copy">unique competition<br> entries</p>
                </div>
              </div>
              <div class="col-12 col-xs-6 col-lg-4">
                <div class="results__box">
                <h3 class="results__heading">
                  <count-to
                          ref="counter_3"
                          :startVal="0"
                          :endVal="5826"
                          :duration=3200
                          :decimals="0"
                          :autoplay="false"
                          separator=","
                          prefix="+"
                  />
                </h3>
                <p class="results__copy">new social media<br> followers</p>
                </div>
              </div>
              <div v-waypoint="{ active: true, callback: onWaypoint }"/>
              <div class="col-12 col-xs-6 col-lg-4">
                <div class="results__box">
                <h3 class="results__heading">
                  <count-to
                          ref="counter_4"
                          :startVal="0"
                          :endVal="3"
                          :duration=4000
                          :decimals="0"
                          :autoplay="false"
                          separator=""
                          prefix=""
                          suffix="m"
                  />
                  <count-to
                          ref="counter_5"
                          :startVal="0"
                          :endVal="49"
                          :duration=4000
                          :decimals="0"
                          :autoplay="false"
                          separator=""
                          prefix=""
                          suffix="s"
                  />
                </h3>
                <p class="results__copy">average time on<br> page per user</p>
                </div>
              </div>
              <div class="col-12 col-xs-6 col-lg-4">
                <div class="results__box">
                <h3 class="results__heading">
                  <count-to
                          ref="counter_6"
                          :startVal="0"
                          :endVal="107737"
                          :duration=4000
                          :decimals="0"
                          :autoplay="false"
                          separator=","
                          prefix=""
                          suffix=""
                  />
                </h3>
                <p class="results__copy">page views</p>
                </div>
              </div>
              <div class="col-12 col-xs-6 col-lg-4">
                <div class="results__box">
                <h3 class="results__heading">
                  <count-to
                          ref="counter_7"
                          :startVal="0"
                          :endVal="61"
                          :duration=4000
                          :decimals="0"
                          :autoplay="false"
                          separator=""
                          prefix=""
                          suffix="%"
                  />
                </h3>
                <p class="results__copy">conversion rate</p>
                </div>
              </div>
              </div>
            </div>
            </div>
          </div>

    </main>
  </div>
</template>

<script>
import '@/assets/scss/styles.scss';
import Flickity from 'vue-flickity';
import countTo from 'vue-count-to';

import SvgLogoJnto from '@/assets/images/logo-jnto.svg';
import SvgLogoJal from '@/assets/images/logo-jal.svg';
import SvgLogoJed from '@/assets/images/logo-jed.svg';
import SvgLogoGa from '@/assets/images/logo-ga.svg';
import IcoArrow from '@/assets/images/ico-arrow-right.svg';

export default {
  components: {
    Flickity,
    countTo,

    // SVGs
    SvgLogoJnto,
    SvgLogoJal,
    SvgLogoJed,
    SvgLogoGa,
    IcoArrow,
  },
  data() {
    return {
      flickityOptions: {
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        adaptiveHeight: true
      }
    }
  },
  methods: {
    onWaypoint({ going, direction }) {
      const self = this;
      if (going === this.$waypointMap.GOING_IN) {
        Object.keys(this.$refs).forEach(name => {
          if (/^counter_/.test(name)) {
            self.$refs[name].start();
          }
        })
      }
    },
    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    }
  }
}
</script>

<style lang="scss">
.header {
  max-width: 1440px;
  margin: 0 auto;
}

body {
    overflow-x: hidden;
    background: black url(assets/images/bg-texture.jpg) 0 0 repeat;
}

.header {
  position: relative;
  min-height: 380px;
  background: transparent url(assets/images/header-image.png) 50% 0 / contain no-repeat;
  background-size: auto 100%;
}

.header-inner {
    position: absolute;
    top: 50%;
    left: 0;
    z-index: 2;
    width: 100%;
  transform: translateY(-70%);
}

.header-logos-outer {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header__logo {
  width: auto;
  &--jal {
    height: 39px;
    transform: translateY(-8px);
  }
}

.header__bg {
  opacity: 0;
}

.header__subheading {
  @include site-subheading;
  text-transform: uppercase;
}

.slider-arrows {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50%;
  transform: translateX(-50%);
  @include media-breakpoint-down(xl) {
    width: 70%;
  }
  @include media-breakpoint-down(lg) {
    width: 90%;
  }
}

.slider__arrow {
  position: absolute;
  top: 50%;
  left: 0;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translateY(-50%);
  border: none;
  background: none;
  outline: none;

  &--right {
    left: auto;
    right: 0;
  }
  &--left {
    transform: translateY(-50%) rotate(180deg);
  }
}

.carousel-cell {
  opacity: 0.17;
  &.is-selected {
    opacity: 1;
  }

  @include media-breakpoint-down(sm) {
    img {
      width: 320px;
      height: 223px;
    }
  }
}

.results__box {
  min-height: 185px;
  margin: 1rem;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  border-radius: 4px;
  border: solid 1px #474747;
  background-image: linear-gradient(to bottom, #1b1b1b, rgba(27, 27, 27, 0));
}

.results__heading {
  @include stats-heading;
}

.results__copy {
  @include stats-copy;
}

p a {
  color: $red;
  &:hover {
    color: $red;
  }
}

</style>
